import { END_POINTS } from "../constants/url";
import { CommonBody } from "../types/General";
import emptySplitApi from "../utils/rtk";

interface CommonResponseType {
  status: number;
  message: string;
  statusCode: number;
}


export const ToneApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getTone: builder.query<
      CommonResponseType & { data: any },
      {
        search?: string;
        length?: number;
        start?: number;
      }
    >({
      query: ({ length, search, start }) => ({
        url: `${END_POINTS.getTone}?start=${start}&length=${length}` +
          (search?.length ? `&search=${search}` : ""),
        method: "GET",
      }),
    }),
    getToneById: builder.query<
      CommonResponseType & { data: any },
      {
        id: number;
      }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.getToneById}${id}/`,
        method: "GET",
      }),
    }),
    addTone: builder.mutation<
      CommonResponseType & { data: any },
      { body: CommonBody }
    >({
      query: ({ body }) => ({
        url: END_POINTS.addTone,
        method: "POST",
        body,
      }),
    }),
    updateTone: builder.mutation<CommonResponseType, { body: any; id: number }>({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateTone}${id}/`,
        method: "PUT",
        body,
      }),
    }),

    deleteTone: builder.mutation<CommonResponseType, { id: number }>({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteTone}${id}/`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
useAddToneMutation,
useUpdateToneMutation,
useLazyGetToneByIdQuery,
useLazyGetToneQuery,
useDeleteToneMutation
} = ToneApi;
